import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { ListGroupOriginResponse } from '../../responses/medical-record/list-group-origin.response';
import { GroupOriginResponse } from '../../responses/medical-record/group-origin.response';
import { GroupOriginRequest } from '../../requests/medical-record/group-origin.request';

@Injectable({
  providedIn: 'root'
})
export class GroupOriginService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public listGroupOrigin(): Observable<ListGroupOriginResponse> {
    let uri = `GroupOrigin/getAll`

    return this.httpClient.get<ListGroupOriginResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getGroupOrigin(idGroupOrigin: number): Observable<GroupOriginResponse> {
    let uri = `GroupOrigin/idGroupOrigin/${idGroupOrigin}`

    return this.httpClient.get<GroupOriginResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
  
  public postGroupOrigin(request: GroupOriginRequest): Observable<ReturnStruct> {
    let uri = `GroupOrigin`

    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public putGroupOrigin(request: GroupOriginRequest): Observable<ReturnStruct> {
    let uri = `GroupOrigin`

    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteGroupOrigin(idGroupOrigin: number): Observable<ReturnStruct> {
    let uri = `GroupOrigin/idGroupOrigin/${idGroupOrigin}`

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}